
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cards/[uuid]",
      function () {
        return require("private-next-pages/cards/[uuid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cards/[uuid]"])
      });
    }
  